module.exports = __webpack_public_path__ + "static/media/Estampa_Card2.bb100181.png";